<template>
    <div class="uk-container uk-container-expand uk-animation-slide-top-small uk-animation-fast">
        <!-- Zoom Controls -->
        <div class="zoom-in-out">
            <a @click="zoom('in')" class="zoom-button uk-text-muted"><i class="material-icons">zoom_in</i></a>
            <a @click="zoom('out')" class="zoom-button uk-text-muted uk-margin-small-top"><i class="material-icons">zoom_out</i></a>
        </div>

        <!-- Single Image -->
        <div class="image-top-padding"></div>     
        <div>       
            <figure v-if="globalImages.uploadedImages[0].dataURL" class="zoom" @mousemove="hoverZoom" v-bind:style="{width: imgZoom + '%', backgroundImage: 'url(' + globalImages.uploadedImages[0].dataURL + ')'}">
                <img :src="globalImages.uploadedImages[0].dataURL" />
            </figure>   
            <figure v-else class="zoom" @mousemove="hoverZoom" v-bind:style="{width: imgZoom + '%', backgroundImage: 'url(' + globalImages.uploadedImages[0].thumbnailURL + ')'}">
                <img :src="globalImages.uploadedImages[0].thumbnailURL" />
            </figure> 
        </div>
            
        <!-- Restart Button -->
        <div class="uk-text-center uk-padding-small">
            <button @click="restart()" class="uk-button uk-button-default uk-button-small uk-text-muted uk-text-capitalize" style="border-radius: 20px;"><i>Restart</i></button>
        </div>        
    </div>
</template>

<script>

    export default {
        name: 'single-apply',
        data() {
            return {
                imgZoom: 70
            }
        },
        methods: {
            zoom: function(direction) {
                if (direction === 'in') {
                    this.imgZoom = this.imgZoom + 5 // takes smaller number (basically max 90)                    
                } 
                if (direction === 'out') {
                    this.imgZoom = this.imgZoom - 5
                }
            },
            restart: function() {
                var me;
                me = this;

                UIkit.modal.confirm('<b>Restart?</b> <br> Are you sure you want to remove <b>' + me.globalImages.uploadedImages.length + ' images</b> from queue and restart?')
                .then(function () {
                    me.globalImages.uploadedImages = [];
                    me.globalSessionInfo.compressOnImport = null; 
                    me.globalSessionInfo.appliedWatermark = false;
                    me.globalSessionInfo.appliedWatermarkIndex = null;

                }, function () {
                }); 
            }, 
            hoverZoom: function(e) { 
                var zoomer = e.currentTarget;
                var offsetX, offsetY, x, y
                
                e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
                e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
                x = offsetX/zoomer.offsetWidth*100
                y = offsetY/zoomer.offsetHeight*100
                zoomer.style.backgroundSize = '160%';
                zoomer.style.backgroundPosition = x + '% ' + y + '%';       
            }           
        },
        mounted() {     
        }
    }
</script>

<style scoped>
    .zoom-in-out {
        position: absolute;
        margin-top: 40px;
        height: 40px;
        width: 40px;               
        z-index: 5; 
    }   

    .zoom-button {
        box-sizing: border-box;
        width: 36px;
        height: 36px;
        border-radius: 500px;
        background: #f8f8f8;
        vertical-align: middle;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        transition: .1s ease-in-out;
        transition-property: color,background-color;
        -webkit-user-select: none; /* Safari */        
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE10+/Edge */
        user-select: none; /* Standard */
    }

    .zoom-button:hover {
        box-sizing: border-box;
        width: 36px;
        height: 36px;
        border-radius: 500px;
        background: #eeeeee;
        vertical-align: middle;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        transition: .1s ease-in-out;
        transition-property: color,background-color;
    }    

    a {
        text-decoration: none;
    }

    /* Hover Zoom */
    .image-top-padding {
        height: 40px;
        width: 100%;
    }

    figure.zoom {
        margin: auto;
        background-position: 50% 50%;
        position: relative;
        width: 90%;
        overflow: hidden;
        cursor: zoom-in;
        box-shadow: 0 14px 25px rgba(0,0,0,.16);
    }
    
    figure.zoom img:hover {
        opacity: 0;
    }
    
    figure.zoom img {
        transition: opacity .5s;
        display: block;
        width: 100%;
    }    

</style>